import { render } from "./Anime.vue?vue&type=template&id=5063a550&scoped=true"
import script from "./Anime.vue?vue&type=script&lang=js"
export * from "./Anime.vue?vue&type=script&lang=js"

import "./Anime.vue?vue&type=style&index=0&id=5063a550&scoped=true&lang=css"

import exportComponent from "/Users/projects/crud/AVTO-SERVIS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5063a550"]])

export default __exports__